import React, { useContext, useEffect } from 'react';
import { StreamChat } from 'stream-chat';
import { GlobalContext } from './GlobalState';
import { Chat, enTranslations, Streami18n } from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';
import './App.css';

// import { useChecklist } from './ChecklistTasks';
import { cookieConfig, delayPromise, notificationInit } from './utils';
import { SideBarLogoXpel } from './assets';
import ChatDashboard from './components/ChatDashboard';
import axios from 'axios';
import Button from '@mui/material/Button';

const i18nInstance = new Streami18n({ language: 'en', translationsForLanguage: { ...enTranslations } });
const App = () => {
  const { globalState, setGlobalState } = useContext(GlobalContext);
  // console.log('globalState', globalState)
  useEffect(() => {
    const connectGS = async () => {
      try {
        // Checking Notifications
        await notificationInit();
        // Cookie
        let app_config = cookieConfig();
        if (app_config.authToken === 'none') throw Error('authtoken-is-missing');
        // Obtaining apiKey
        const request = { 'token': app_config.authToken };
        const response = await axios.post(app_config.authEnv+'/token_validation', request);
        if (response.status === 200 && response.data && response.data.result === true) {
          app_config = {
            ...app_config,
            gsUserToken: response.data.userToken || 'none',
            gsUserId: response.data.userId || 'none',
            gsApiKey: response.data.apiKey || 'none'
          };
          if (app_config.gsUserToken === 'none' || app_config.gsUserId === 'none' || app_config.gsApiKey === 'none') throw Error('invalid-gs-credentials');
          else {
            const app_gsclient = new StreamChat(app_config.gsApiKey, {timeout: 30000});
            await app_gsclient.connectUser({ id: app_config.gsUserId }, app_config.gsUserToken);
            setGlobalState.connect({ app_config: app_config, app_gsclient: app_gsclient});
          }
        }
        else throw Error('token-not-valid');
      }
      catch (err) {
        console.log(err.message || err);
        setGlobalState.error();
      }
    };
    connectGS();
    // Disconnect on UnMount
    return async () => {
      if (globalState.app_gsclient) {
        await globalState.app_gsclient.disconnectUser().then(() => {
          console.log('Connection has been closed');
          setGlobalState.disconnect();
        });
      }
      console.log('Unmount');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchIdxs = async () => {
      try {
        const idxData = { prime_unread: [], prime_categories: {}, ch_list: {} };
        // Obtaining unread prime cids
        const reqDefault = { 'token': globalState.app_config.authToken };
        const resFirst = await axios.post(globalState.app_config.authEnv+'/channels/list/prime/unread', reqDefault);
        if (resFirst.status === 200 && resFirst.data && typeof resFirst.data === 'object' && Array.isArray(resFirst.data) === true && resFirst.data !== null) {
          idxData.prime_unread = [...resFirst.data];
        }
        else throw Error('error-fetchIdxs-step1');
        // Obtaining phonebook categories
        const resSecond = await axios.post(globalState.app_config.authEnv+'/address_book/categories', reqDefault);
        if (resSecond.status === 200 && resSecond.data && resSecond.data.result === true && typeof resSecond.data.categories === 'object' && Array.isArray(resSecond.data.categories) === true && resSecond.data.categories !== null) {
          resSecond.data.categories.map(category => idxData.prime_categories[category.title] = category.id);
        }
        else throw Error('error-fetchIdxs-step2');
        // Obtaining index
        const reqIndex = { ...reqDefault, types: ['prime', 'team', 'direct']};
        const resThird = await axios.post(globalState.app_config.authEnv+'/channels/list', reqIndex);
        if (resThird.status === 200 && resThird.data && resThird.data.result === true && typeof resThird.data.channels === 'object' && Array.isArray(resThird.data.channels) === true && resThird.data.channels !== null) {
          resThird.data.channels.map(ch_item => idxData.ch_list[ch_item.cid] = {
            ...ch_item,
            state: {
              ...ch_item.state,
              unreadCount: 0,
              last_message_at: ch_item.state.last_message_at ? new Date(ch_item.state.last_message_at) : new Date(0),
              messages: Array.isArray(ch_item.state.messages) === true && ch_item.state.messages.length > 0 ? ch_item.state.messages.reverse() : null
            }
          });
          if (Object.keys(idxData.ch_list).length !== resThird.data.count) throw Error('error-backend-data-3-count');
        }
        else throw Error('error-fetchIdxs-step3');
        // Obtaining channels
        if (idxData.prime_unread.length > 0) {
          let gs_FiltersPrime = { type: { $in: ['prime'] }, members: { $in: [globalState.app_gsclient.userID] }, cid: {$in: [...idxData.prime_unread]}, joined: true };
          let gs_sortPrime = [{ last_message_at: -1 }];
          let gs_OptsPrime = { state: true, watch: true, limit: 30, offset: 0, message_limit: 25 };
          let gs_unreadPrime = await globalState.app_gsclient.queryChannels(gs_FiltersPrime, gs_sortPrime, gs_OptsPrime);
          while (gs_unreadPrime.length < idxData.prime_unread.length) {
            await delayPromise(100);
            gs_OptsPrime.offset += gs_OptsPrime.limit;
            let loopChannels = await globalState.app_gsclient.queryChannels(gs_FiltersPrime, gs_sortPrime, gs_OptsPrime);
            if (loopChannels.length > 0) gs_unreadPrime = [...gs_unreadPrime, ...loopChannels];
          }
          gs_unreadPrime.map(ch_item => idxData.ch_list[ch_item.cid] = ch_item);
        }
        // Obtaining channels
        await delayPromise(100);
        let queryLoop = false;
        // let queryFilters = { type: { $in: ['team', 'direct'] }, members: { $in: [globalState.app_gsclient.userID] }, joined: true };
        let queryFilters = { type: { $in: ['team', 'direct'] }, members: { $in: [globalState.app_gsclient.userID] } };
        let querySort = [{ has_unread: -1 }];
        let queryOptions = { state: true, watch: true, limit: 20, offset: 0, message_limit: 25 };
        let channelsArray = await globalState.app_gsclient.queryChannels(queryFilters, querySort, queryOptions);
        if (channelsArray.length === queryOptions.limit && channelsArray[channelsArray.length - 1]['state']['unreadCount'] > 0) queryLoop = true;
        while (queryLoop === true) {
          await delayPromise(100);
          queryOptions.offset += queryOptions.limit;
          let loopChannels = await globalState.app_gsclient.queryChannels(queryFilters, querySort, queryOptions);
          if (loopChannels.length > 0) channelsArray = [...channelsArray, ...loopChannels];
          if (loopChannels.length === 0 || loopChannels[loopChannels.length - 1]['state']['unreadCount'] === 0) queryLoop = false;
        }
        channelsArray.map(ch_item => idxData.ch_list[ch_item.cid] = ch_item);
        setGlobalState.boot(idxData);
      } catch (err) {
        console.log(err);
        setGlobalState.error();
      }
    };
    if (globalState.app_stage === 'connected') fetchIdxs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.app_stage])

  if (globalState.app_stage === 'error') return (
    <div className='app__wrapper-loading'>
      <span className='app_wrapper-loading_logo'><SideBarLogoXpel /></span>
      <p>{'Error has been encountered. Please log in again.'}</p>
    </div>
  )
  if (globalState.app_stage === 'disconnected') return (
    <div className='app__wrapper-loading'>
      <span className='app_wrapper-loading_logo'><SideBarLogoXpel /></span>
      <p>{'Client has been disconnected'}</p>
      <Button variant='text' onClick={() => document.location.reload()}>{'Connect'}</Button>
    </div>
  )
  if (globalState.app_stage === '') return (
    <div className='app__wrapper-loading'>
      <span className='app_wrapper-loading_logo'><SideBarLogoXpel /></span>
      <p>{'Booting...'}</p>
    </div>
  )
  if (globalState.app_stage === 'connected') return (
    <>
      <div className='app__wrapper-loading'>
        <span className='app_wrapper-loading_logo'><SideBarLogoXpel /></span>
        <p>{'Fetching Channels...'}</p>
      </div>
    </>
  )
  if (globalState.app_stage === 'booted') return (
    <div className='app__wrapper'>
      <Chat client={globalState.app_gsclient} i18nInstance={i18nInstance} theme={`team light`}>
        <ChatDashboard />
      </Chat>
    </div>
  )
};

export default App;